import { useEffect, useState } from 'react';

export const useProgressiveImage = (src: string) => {
    const [sourceLoaded, setSourceLoaded] = useState<string | null>(null);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const img = new Image();
        img.src = src;
        img.onload = () => setSourceLoaded(src);
        setLoaded(true);
        return () => {
            setLoaded(false);
        };
    }, [src]);

    return { sourceLoaded, loaded };
};
